import React, { FC } from "react"

import { renderRichText } from "gatsby-source-contentful/rich-text"

import { AccordionBlockFragmentFragment } from "@graphqlTypes"

import Accordion, {
  ACCORDION_SIZES,
} from "@components/Accordion/Accordion"

import { CHECKMARK_VARIANT } from "@components/lp/AccordionBlock/AccordionBlock"

import { ContentDIV } from "@components/Content/Content.styles"

type AccordionListProps = {
  items: AccordionBlockFragmentFragment["items"]
  checkmark: AccordionBlockFragmentFragment["checkmark"]
  size?: ACCORDION_SIZES
}

/* Since this component consumes Contentful Data only, it has not been put in the components/Accordion folder */
const AccordionList: FC<AccordionListProps> = ({ items, checkmark, size }) => {
  return (
    <div className="AccordionList">
      {items &&
        items.map((item, i) => (
          <Accordion
            hideCheck={!!checkmark && checkmark === CHECKMARK_VARIANT.DEFAULT}
            key={`item.title${i}`}
            size={size || ACCORDION_SIZES.L}
            title={item?.title || ""}
          >
            <ContentDIV>
              {!!item?.content &&
                typeof item.content.raw === "string" &&
                renderRichText({ raw: item.content.raw, references: [] })}
            </ContentDIV>
          </Accordion>
        ))}
    </div>
  )
}

export default AccordionList
